
if (!customElements.get('custom-pagination')) {
	class CustomPagination extends HTMLElement {
		constructor() {
			super()
			this.init()
			// document.addEventListener("on:bfcache:load-restore", this.reload.bind(this))
		}
		disconnectedCallback() {
			this.destroy()
		}
		init() {
			this.restoreState()
			this.infiniteScroll = this.dataset.paginationType === 'pagination_infinite'
			this.modernPagination = this.dataset.paginationType === 'pagination_new'
			this.pagination = this.querySelector('.js-pagination')
			this.loadMoreButton = this.querySelector('.js-pagination-load-more')
			this.loadingDivParent = this.querySelector('.loading-state-parent')
			this.results = this.querySelectorAll('.js-pagination-result:not(.product-not-available)')
			this.quickBuyButtons = this.querySelectorAll('.js-quick-buy')
			this.controller = null

			// Bind click handlers to pagination results
			this.resultClickHandler = this.resultClickHandler || this.handleResultClick.bind(this)
			this.addEventListener('click', this.resultClickHandler)

			// Bind click handler to load more button click
			this.loadMoreClickHandler = this.loadMoreClickHandler || this.handleLoadMoreClick.bind(this)

			if (this.pagination && this.pagination.dataset.isMoreResults && this.results) {
				if (this.loadMoreButton) this.loadMoreButton.addEventListener('click', this.loadMoreClickHandler)

				if (this.infiniteScroll) {
					this.paginationObserver = new IntersectionObserver(
						(entries) => {
							entries.forEach((entry) => {
								if (entry.isIntersecting) {
									this.loadMore()

									// Continue to load results as long as the 'load more' button is visible
									this.intersectingTimer = setInterval(this.loadMore.bind(this), 1000)
								} else if (this.intersectingTimer) {
									clearInterval(this.intersectingTimer)
								}
							})
						},
						{ rootMargin: `${window.innerHeight * 1.5}px 0px` }
					)
					this.paginationObserver.observe(this.pagination)
				}
			} else if (this.dataset.availableFirst === 'true') {
				this.loadNotAvailable()
			}
			document.addEventListener('DOMContentLoaded', () => {
				const quickBuyPopup = this.querySelector('.quick-buy-popup')
				this.quickBuyButtons.forEach((quickBuy) => {
					quickBuy.addEventListener('click', () => {
						const zip = readCookie('zip')
						if (!zip) {
							quickBuyPopup.classList.add('cc-popup--visible')
						} else {
							const submitButton = this.querySelector('#quick-buy-product-block')
							submitButton.click()
						}
					})
				})
				this.closeQuickBuyButton = this.querySelector('.cc-popup-close')
				this.closeQuickBuyButton.addEventListener('click', () => {
					quickBuyPopup.classList.remove('cc-popup--visible')
				})
			})
		}
		//destroy
		destroy() {
			if (this.intersectingTimer) clearInterval(this.intersectingTimer)
			if (this.paginationObserver) this.paginationObserver.disconnect()
			if (this.loadMoreButton) this.loadMoreButton.removeEventListener('click', this.loadMoreClickHandler)
			this.removeEventListener('click', this.resultClickHandler)
			this.loadMoreClickHandler = null
		}
		//reload
		reload() {
			this.destroy()
			this.init()
		}
		//handleloadmoreclick
		handleLoadMoreClick(evt) {
			evt.preventDefault()
			this.loadMore()
		}
		//handleresulclick
		handleResultClick(evt) {
			if (evt.target.closest('a') && evt.target.closest('.js-pagination-result') && this.controller) {
				this.controller.abort()
			}
		}
		//loadmore
		async loadMore() {
			if (!this.isFetching && this.dataset.pauseInfiniteScroll === 'false') {
				this.isFetching = true
				this.controller = new AbortController()

				try {
					//this.addLoadingState()
					const tmpl = await this.fetchNextPage()
					this.appendAdditionalResults(tmpl)
					this.updatePaginationContent(tmpl)
          theme.ProductBlockManager.loadImages();
				} catch (error) {
					console.log('Unable to fetch next page of results', error) // eslint-disable-line
					if (this.intersectingTimer) clearInterval(this.intersectingTimer)
				} finally {
					//this.removeLoadingState()
					//this.saveState()
					this.isFetching = false
          theme.ProductBlockManager.loadImages();
				}
			}
		}
		addLoadingState() {
			if (!this.loadingDivParent) throw new Error('No loadig state found')
			if (!this.pagination) throw new Error("No 'loading controller' found")

			this.pagination.style.display = 'none'
			this.loadingDivParent.style.display = 'block'
		}

		async fetchNextPage() {
			const link = this.loadMoreButton.href || this.loadMoreButton.getAttribute('data-href')
			const response = await fetch(link, {
				signal: this.controller.signal,
			})

			if (!response.ok) throw new Error(response.status)
			if (this.dataset.pauseInfiniteScroll === 'true') {
				throw new Error('Infinite scroll was interrupted.')
			}

			const tmpl = document.createElement('template')
			tmpl.innerHTML = await response.text()

			return tmpl
		}

		appendAdditionalResults(tmpl) {
			let newResultsHtml = ''
			const lastResult = this.results[this.results.length - 1]
			tmpl.content.querySelectorAll('.js-pagination-result').forEach((result) => {
				newResultsHtml += result.outerHTML
			})
			lastResult.insertAdjacentHTML('afterend', newResultsHtml)
			theme.initAnimateOnScroll()
			this.results = this.querySelectorAll('.js-pagination-result')
		}

		updatePaginationContent(tmpl) {
			const newPagination = tmpl.content.querySelector('.js-pagination')
			if (newPagination && newPagination.dataset.isMoreResults) {
				this.pagination.innerHTML = newPagination.innerHTML

				// Rebind to the new load more button
				if (!this.loadMoreButton?.classList.contains('disabled')) {
					this.loadMoreButton.removeEventListener('click', this.loadMoreClickHandler)
					this.loadMoreButton = this.querySelector('.js-pagination-load-more')
					this.loadMoreButton.addEventListener('click', this.loadMoreClickHandler)
				}
			} else {
				this.pagination.remove()
				if (this.intersectingTimer) clearInterval(this.intersectingTimer)
				if (this.paginationObserver) this.paginationObserver.disconnect()
				document.querySelectorAll('.js-when-paginated-only').forEach((elem) => elem.remove())

				if (this.dataset.availableFirst === 'true') {
					// append not available products
					this.loadNotAvailable()
				}
			}
		}

		loadNotAvailable() {
			const productsNotAvailable = this.querySelectorAll('.product-not-available')
			let newResultsHtml = ''
			const lastResult = this.results[this.results.length - 1]
			const parentList = this.querySelector('ul.product-list')
			productsNotAvailable.forEach((element) => {
				element.style.display = ''
				newResultsHtml += element.outerHTML
				element.remove()
			})
			parentList.children?.length ? lastResult.insertAdjacentHTML('afterend', newResultsHtml) : (parentList.innerHTML = newResultsHtml)
			this.results = this.querySelectorAll('.js-pagination-result')
		}

		removeLoadingState() {
			this.controller = null
			if (this.loadingDivParent) {
				this.loadingDivParent.style.display = 'none'
			}
			if (this.pagination) {
				this.pagination.style.display = 'block'
			}
		}

		saveState() {
			console.log('SAVE STATE')
			const productList = document.querySelector('.product-list').innerHTML // Assuming product items have the class 'product-item'
			const loadMoreButton = document.querySelector('.container.pagination-row').innerHTML

			sessionStorage.setItem('productListHTML', productList)
			sessionStorage.setItem('loadMore-button', loadMoreButton)
		}

		restoreState() {
			const savedHTML = sessionStorage.getItem('productListHTML')
			const loadMoreButton = sessionStorage.getItem('loadMore-button')

			if (savedHTML) {
				const tempDiv = document.createElement('div')

				tempDiv.innerHTML = savedHTML

				const productsEl = tempDiv.querySelectorAll('.js-pagination-result > .product-block')

				productsEl.forEach((item) => {
					item.removeAttribute('cc-animate-init')
					item.removeAttribute('data-cc-animate')
				})

				document.querySelector('.product-list').innerHTML = tempDiv.innerHTML
				document.querySelector('.container.pagination-row').innerHTML = loadMoreButton

				return true
			}
			return false
		}
	}

	customElements.define('custom-pagination', CustomPagination)
}